import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import { HiOutlineUserCircle } from 'react-icons/hi'
import { RiDashboard3Line } from 'react-icons/ri';
import { FaUsers, FaFlagCheckered, FaTools, FaCoffee } from 'react-icons/fa';
import { FiTrendingDown } from 'react-icons/fi'
import { MdAdminPanelSettings } from 'react-icons/md'
import Cookies from 'universal-cookie';
import cookieUtils from "../../Utilities/CookieUtils";
import logo from '../DownhillFantasyLogo4.png'
import rampageLogo from '../rampage_logo.png'
import { useState, useEffect } from "react";
import { useLocation } from 'react-router-dom';
import './index.css'

const NavBar = (props) => {
    const cookies = new Cookies()
    const cookie = cookies.get('jwt')
    const { scope, userId } = cookieUtils.getScopeFromJWT(cookie)
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

    const getFirstPathname = () => {
        const pathname = window.location.pathname;

        if (pathname.includes('rampage')) {
            return 'rampage'
        }

        if (pathname.includes('crankworx')) {
            return 'crankworx'
        }

        return ''

    }

    const location = useLocation();

    const [series, setSeries] = useState('')
    useEffect(() => {
        // When the component mounts, parse the pathname to get the first part
        const pathnameParts = window.location.pathname.split('/');
        console.log(pathnameParts)
        if (pathnameParts.length >= 3) {
            setSeries(pathnameParts[1]); // Update the series state
        }
    }, []);


    return (
        <>
            <Navbar bg="light" variant="light" expand="sm" sticky="top">
                <Container style={{ minHeight: '40px' }} className='d-flex align-items-center justify-content-center'>
                    {/* Add your links and components for the lower Navbar here */}

                    <Nav className="mx-auto" style={{maxHeight:'4rem'}}>
                        {props.isLoggedIn && <>
                            <button
                                className={(!location.pathname.toLowerCase().includes('rampage') && !location.pathname.includes('crankworx')) ? 'top-nav-active px-3 border-0 ' : ' px-3 border-0 bg-light'}
                                onClick={() => { setSeries(''); window.location.href = '/'; }} style={{ height: '2.5rem' }}>
                                <FiTrendingDown className='mb-1 me-1' />
                                UCI Downhill
                            </button>
                            <button
                                className={location.pathname.toLowerCase().includes('rampage') ? 'top-nav-active px-3 border-0 ' : 'px-3 border-0 bg-light'}
                                onClick={() => { setSeries('rampage'); window.location.href = '/rampage/'; }} style={{ height: '2.5rem' }}>
                                <FaTools className='mb-1 me-2' />
                                Rampage
                            </button>
                            {/* <button
                                className={location.pathname.includes('crankworx') ? 'top-nav-active px-3 border-0 ' : 'px-3 border-0 bg-light'}
                                onClick={() => { setSeries('crankworx'); window.location.href = '/crankworx/'; }}>
                                <FaCoffee className='mb-1 me-1' />
                                Crankworx
                            </button> */}
                        </>}
                    </Nav>
                </Container>
            </Navbar>
            <Navbar bg="dark" variant='dark' expand="lg" sticky='top'>
                <Container style={{ minHeight: '40px' }}>
                    {/* <NavBar.Brand><img src={logo}></img> </NavBar.Brand> */}
                    {!isMobileMenuOpen && <Navbar.Brand href={location.pathname.toLowerCase().includes('rampage') ? "/rampage/" : "/"} className='navbar-font' style={{ minWidth: '165px' }}>{location.pathname.toLowerCase().includes('rampage') ? <img src={rampageLogo} className='logo'></img> : <img src={logo} className='logo'></img> }</Navbar.Brand>}
                    <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} />
                    <Navbar.Collapse id="basic-navbar-nav">

                        <Nav className="me-auto">
                            {props.isLoggedIn && <>
                                <Nav.Link href={`/${series ? series + '/' : ''}`} className={location.pathname === '/' ? 'nav-active px-3' : location.pathname === '/rampage/' ? 'nav-active-rampage px-3': 'px-3'}><RiDashboard3Line className='mb-1' /> Dashboard</Nav.Link>
                                <Nav.Link href={`/${series ? series + '/leagues' : 'leagues'}`} className={location.pathname === '/leagues' ? 'nav-active px-3' : location.pathname === '/rampage/leagues' ? 'nav-active-rampage px-3': 'px-3'}><FaUsers className='mb-1 me-1' />Leagues</Nav.Link>
                                {!location.pathname.toLowerCase().includes('rampage') && <Nav.Link href={`/${series ? series + '/events' : 'events'}`} className={location.pathname === '/events' ? 'nav-active px-3' : location.pathname === '/rampage/events' ? 'nav-active-rampage px-3': 'px-3'}><FaFlagCheckered className='mb-1' /> Results</Nav.Link>}
                                {scope == 'admin' && <Nav.Link href="Admin" className={location.pathname === '/admin' ? 'nav-active px-3' : location.pathname === '/rampage/admin' ? 'nav-active-rampage px-3': 'px-3'}><MdAdminPanelSettings className='mb-1' />Admin</Nav.Link >}
                            </>}
                        </Nav>
                        {props.isLoggedIn && <Form className="d-flex">
                            <Nav.Link className="text-secondary px-3 py-2 hover-light" href='Profile'><HiOutlineUserCircle size={20} className='mb-1 me-1'></HiOutlineUserCircle>{props.userName}</Nav.Link>

                            <Button variant="outline-light" onClick={props.handleLogout}>Logout</Button>
                        </Form>}
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </>

    );
}

export default NavBar;